import script from "./SelectNumberField.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectNumberField.vue?vue&type=script&setup=true&lang=js"

import "./SelectNumberField.vue?vue&type=style&index=0&id=fe972c3a&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe972c3a"]])

export default __exports__